import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navbar.css';
import AnimatedLetterSwitcher from './AnimatedLetterSwitcher';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className='navbar-container'>
        {/* Logo */}
        <div className='navbar-logo'>
          <div
            className='navbar-logo'
            onClick={() => scrollToSection('hero')}
            aria-label='Go to home'
          >
            <span className='navbar-brand'>
              <AnimatedLetterSwitcher />
              <span className='navbar-brand-rest'>toryEngine</span>
            </span>
          </div>
        </div>

        {/* Desktop Menu */}
        <div className='navbar-menu'>
          <button
            className='nav-link'
            onClick={() => scrollToSection('the-system')}
            data-testid='nav-features-link'
          >
            Features
          </button>
          <button
            className='nav-link'
            onClick={() => scrollToSection('how-it-works')}
            data-testid='nav-how-it-works-link'
          >
            How It Works
          </button>
          <button
            className='nav-link-cta'
            onClick={() => scrollToSection('signup')}
            data-testid='nav-get-started-btn'
          >
            Get Started
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className='mobile-menu-toggle'
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          data-testid='mobile-menu-toggle'
          aria-label='Toggle menu'
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className='mobile-menu active'>
          <button
            className='nav-link'
            onClick={() => scrollToSection('the-system')}
          >
            Features
          </button>
          <button
            className='nav-link'
            onClick={() => scrollToSection('how-it-works')}
          >
            How It Works
          </button>
          <button
            className='nav-link-cta'
            onClick={() => scrollToSection('signup')}
          >
            Get Started
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
